import { withRouter } from "next/router";
import { NextSeo } from "next-seo";
import React from "react";
import { seoFunct } from "../src/config/next-seo.config";
import ComprehensiveTicketing from "../src/pages/ComprehensiveTicketing/ComprehensiveTicketing";

const Ticketing = () => {
	return (
		<>
			<NextSeo {...seoFunct("TicketingSeo")} />
			<ComprehensiveTicketing />
		</>
	);
};

export default withRouter(Ticketing);
